exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile-title[data-v-963b32be] {\n  font-family: \"Roboto Slab\", Tahoma, sans-serif;\n  color: #000;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n}\n", ""]);

// exports
